import { Roles } from '@interfaces/users.interface';

export const mapUserRole = (role: Roles): string => {
  switch (role) {
    case 'admin':
      return 'Amministratore';
    case 'medicalOrganization':
      return 'Organizzazione medica';
    case 'medicalDoctor':
      return 'Dottore';
    case 'patient':
      return 'Paziente';
    default:
      return role;
  }
};

export const mapWeekDay = (dayOfWeek: number): string => {
  switch (dayOfWeek) {
    case 1:
      return 'Lunedì';
    case 2:
      return 'Martedì';
    case 3:
      return 'Mercoledì';
    case 4:
      return 'Giovedì';
    case 5:
      return 'Venerdì';
    case 6:
      return 'Sabato';
    case 7:
      return 'Domenica';
    default:
      return '';
  }
};
